import template from './pipelineDropboxOpportunity.html';
import './style.scss';

export default {
  template,
  bindings: {
    kanbanSortOptions: '<',
    cardViewStates: '<',
    dropboxModel: '=',
    canMoveApplication: '<',
  },
};
